<template>
    <div class="admin">
        <!-- START OF MODALS -->
        <div id="new-device-modal" class="modal" v-if="addNewDevice">
            <div class="modal-body">
                <div class="modal-content">
                    <h3>Tilføj en ny enhed</h3>
                    <span>Pinkode</span>
                    <input placeholder="Pinkode" type="text" v-model="newpin"/>
                </div>
                <div class="modal-action">
                    <div class="btn" v-on:click="claimDevice()">Tilføj</div>
                    <div class="btn" v-on:click="addNewDevice=false,newpin=null">Annuller</div>
                </div>
            </div>
        </div>
        <div id="new-view-modal" class="modal" v-if="newView.show == true">
            <div class="modal-body">
                <div class="modal-content">
                    <h3>Opret en ny visning</h3>
                    <span>Navn</span>
                    <input type="text" placeholder="Navn" v-model="newView.name">
                    <span>Farve</span>
                    <input type="color" v-model="newView.color"/>
                </div>
                <div class="modal-action">
                    <div class="btn" v-on:click="addView()">Opret</div>
                    <div class="btn" v-on:click="newView.show=false,newView.name=null, newView.color=randomColor()">Annuller</div>
                </div>
            </div>
        </div>
        <div id="delete-view-modal" class="modal" v-if="deleteViewKey == true">
            <div class="modal-body">
                <div class="modal-content">
                    <h3>Er du sikker på at du vil slette denne visning?</h3>
                </div>
                <div class="modal-action">
                    <div class="btn warning" v-on:click="deleteView(), deleteViewKey=false">Ja</div>
                    <div class="btn" v-on:click="deleteViewKey=false">Annuller</div>
                </div>
            </div>
        </div>
        <div id="remove-device-modal" class="modal" v-if="removeDeviceKey == true">
            <div class="modal-body">
                <div class="modal-content">
                    <h3>Er du sikker på at du vil fjerne denne enhed?</h3>
                </div>
                <div class="modal-action">
                    <div class="btn warning" v-on:click="removeDevice(), removeDeviceKey=false">Ja</div>
                    <div class="btn" v-on:click="removeDeviceKey=false">Annuller</div>
                </div>
            </div>
        </div>
        <!-- END OF MODALS -->

        <!-- START OF MENU-->
        <div class="nav">
            <div class="logo">
                <span>IT-Master Screen</span>
            </div>
            <div class="links">
                <router-link tag="div" to="/admin/views">Visninger</router-link>
                <router-link tag="div" to="/admin/devices">Enheder</router-link>
            </div>
        </div>
        <!-- END OF MENU-->
        
        <!-- START OF VIEWS-->
        <div class="content" ref="content" v-if="$route.params.param1=='views'">
            <h3 class="screen-title">Visninger ({{views.length}})</h3>
            <div class="screens">
                <router-link v-for="view in views" :key="view.id" :style="'background-color: ' + view.color + ';'" tag="div" :to="'/admin/views/' + view.id">
                    <span class="name">{{view.name}}</span>
                    <span class="id">{{view.id}}</span>
                </router-link>
                <div class="add-new" v-on:click="newView.show = true">
                    <span class="plus">+</span>
                    <span>Opret visning</span>
                </div>
            </div>
            <div class="details" v-if="currentDisplay">
                <div id="preview">
                    <div id="preview-border">
                        <div id="preview-content" :style="'height: ' + currentDisplay.settings.containerSettings.height + 'px; width: ' + currentDisplay.settings.containerSettings.width + 'px'" v-html="contentRender()"></div>
                    </div>
                    <div class="legend">
                        <span title="Skaleringen af forhåndsvisningen">{{scale}}</span>
                        <span> | </span>
                        <span title="Bredde og højde af vinduet i pixels" >{{currentDisplay.settings.containerSettings.width}}x{{currentDisplay.settings.containerSettings.height}}</span>
                    </div>
                </div>
                <div class="settings">
                    <div class="tabs">
                        <div v-on:click="settings=1" :class="{'active': settings==1}">Generelt</div>
                        <div v-on:click="settings=2" :class="{'active': settings==2}">Placering</div>
                        <div v-on:click="settings=3" :class="{'active': settings==3}">Elementer</div>
                    </div>

                    <div v-if="settings == 1">
                        <h4>Generelt</h4>
                        <span>Kaldenavn</span>
                        <input type="text" placeholder="Navn" v-model="currentDisplay.name">
                        <span>Farve</span>
                        <input type="color" v-model="currentDisplay.color">

                        <h4>Skærmstørrelse</h4>
                        <div class="action-line">
                            <div class="btn" v-on:click="newResolution(480,640)">VGA</div>
                            <div class="btn" v-on:click="newResolution(720,1280)">HD</div>
                            <div class="btn" v-on:click="newResolution(1080,1920)">Full HD</div>
                            <div class="btn" v-on:click="newResolution(1440,2560)">QHD</div>
                            <div class="btn" v-on:click="newResolution(2160,3840)">4k</div>
                        </div>
                        <span>Højde (px)</span>
                        <input type="number" v-on:keyup="fixScale()" v-model="currentDisplay.settings.containerSettings.height">
                        <span>Bredde (px)</span>
                        <input type="number" v-on:keyup="fixScale()" v-model="currentDisplay.settings.containerSettings.width">

                        <h4>Design</h4>
                        <span>Style</span>
                        <input type="text" v-model="currentDisplay.settings.containerSettings.style">
                        <span>Baggrundsfarve</span>
                        <input type="color" v-model="currentDisplay.settings.containerSettings.backgroundColor">
                        <span>Baggrundsbillede</span>
                        <div style="display: flex; align-items: center;">
                            <input type="file" v-on:change="previewBackgroundImage" accept="image/*" style="flex-grow: 2;">
                            <div class="btn" v-if="currentDisplay.settings.containerSettings.backgroundImage != null" v-on:click="currentDisplay.settings.containerSettings.backgroundImage = null" style="flex-shrink: 0; margin-left: 5px; height: max-content">Fjern billede</div>
                        </div>
                        <span>Kant størrelse</span>
                        <span class="description">Brug denne indstilling til at kompensere for TV-skærme, der tager en del af billedet. Denne indstilling påvirker ikke baggrundsgrafik.</span>
                        <input type="text" v-model="currentDisplay.settings.containerSettings.border" placeholder="kant størrelse (Eks. 10px)">
                    </div>
                    
                    <div v-if="settings == 2">
                        <h4>Placering af elementer</h4>
                        <!--
                        <span>Placer elementer på skærmen</span>
                        <div class="place-toggle">
                            <div v-on:click="currentDisplay.settings.containerSettings.mode=1" :class="{'active': currentDisplay.settings.containerSettings.mode==1}">
                                <span>I gitter</span>
                                <span class="description">Placer hurtigt elementer i et fastlagt gitter, så du er sikker på at det hele flugter</span>
                            </div>
                            <div v-on:click="currentDisplay.settings.containerSettings.mode=2" :class="{'active': currentDisplay.settings.containerSettings.mode==2}">
                                <span>Fri placering</span>
                                <span class="description">Placer elementer baseret på koordinater for større frihed i placering og størrelse</span>
                            </div>
                        </div>
                        -->
                        <div v-if="currentDisplay.settings.containerSettings.mode==1">
                            <span>Mellemrum mellem elementer</span>
                            <input type="text" v-model="currentDisplay.settings.containerSettings.gap">

                            <h5>Rækker</h5>
                            <span>Rækkehøjde ('1fr' = automatisk højde)</span>
                            <div class="input-row">
                                <input type="text" v-for="n in currentDisplay.settings.containerSettings.rows.length" v-bind:key="n+'row-length'" :placeholder="'Rækkehøjde for række ' + n" v-model="currentDisplay.settings.containerSettings.rows[n - 1]">
                            </div>
                            <div class="action-line">
                                <div class="btn" v-on:click="addRow()">Tilføj række</div>
                                <div class="btn" v-on:click="currentDisplay.settings.containerSettings.rows.splice(currentDisplay.settings.containerSettings.rows.length - 1), currentDisplay.settings.containerSettings.template.splice(currentDisplay.settings.containerSettings.template.length - 1), cleanTemplate()">Fjern række</div>
                            </div>

                            <h5>Kolonner</h5>
                            <span>Kolonnebredde ('1fr' = automatisk bredde)</span>
                            <div class="input-row">
                                <input type="text" v-for="k in currentDisplay.settings.containerSettings.columns.length" v-bind:key="k+'col-length'" :placeholder="'Kolonnebredde for kolonne ' + k" v-model="currentDisplay.settings.containerSettings.columns[k - 1]">
                            </div>
                            <div class="action-line">
                                <div class="btn" v-on:click="addCol()">Tilføj kolonne</div>
                                <div class="btn" v-on:click="currentDisplay.settings.containerSettings.columns.splice(currentDisplay.settings.containerSettings.columns.length - 1), cleanTemplate()">Fjern kolonne</div>
                            </div>

                            <h5>Fordeling af elementer</h5>
                            <span class="description">Angiv hvor dine elementer skal placeres i gitteret ved at skrive elementets ID i de ønskede felter. Sørg for at de ønskede celler former en firkant eller en række.</span>
                            <div class="placement-grid">
                                <div style="display: flex;" v-for="r in currentDisplay.settings.containerSettings.rows.length" v-bind:key="'row-'+r">
                                        <input v-for="c in currentDisplay.settings.containerSettings.columns.length" v-bind:key="'col-'+c" style="width: 0; flex-grow: 2; text-align: center" type="text" :class="'row-'+r+'-col-'+c" v-model="currentDisplay.settings.containerSettings.template[r-1][c-1]"/>
                                </div>
                            </div>
                        </div>

                        <div v-if="currentDisplay.settings.containerSettings.mode==2">
                            Fri placering
                        </div>
                    </div>
                    <div v-if="settings == 3">
                        <h4>Element indhold</h4>
                        <div style="display: flex; margin-bottom: 10px">
                            <select style="flex-grow: 2;" v-model="currentDisplay.settings.selectedElement">
                                <option disabled :value='null'>Vælg et element</option>
                                <option v-for="(element, index) in currentDisplay.settings.elements" v-bind:key="element.id" :value="index">[{{element.id}}] {{element.name + " - " +["Tekst", "Billede", "Ekstern hjemmeside"][element.type -1]}}</option>
                            </select>
                            <div class="btn" title="Tilføj et nyt element" style="margin-left: 5px;" v-on:click='currentDisplay.settings.elements.push({id:getElementID(),name:"Nyt element", type:"text", content:"Hej",time:{in:1,wait:5}, style:"background-color: lightblue"})'>+</div>
                        </div>

                        <div style="margin-top: 15px;" v-if="currentDisplay.settings.selectedElement != null">
                            <h5>Type af indhold</h5>
                            <div style="display: flex; align-items: center; margin-bottom: 15px;">
                                <select style="flex-grow: 2;" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type">
                                    <option value="1">Tekst</option>
                                    <option value="2">Billede</option>
                                    <option value="3">Ekstern hjemmeside</option>
                                    <option value="4">Rå HTML</option>
                                </select>
                            </div>


                            <h5>Navn</h5>
                            <input type="text" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].name">

                            <h5>Design</h5>
                            <input type="text" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].style">

                            <!-- Hvis det er af typen tekst -->
                            <div v-if="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type == 1">
                                <h5 class="override">Indhold</h5>
                                <vue-editor :editorOptions="editorSettings" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].content"></vue-editor>
                            </div>

                            <!-- Hvis det er af typen Billede -->
                            <div v-if="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type == 2">
                                <h5 class="override">Indhold</h5>
                                <div v-for="(image,index) in imageList" :key="image" :style="'background-image: url('+image+'); width:100%; height:150px; background-repeat:no-repeat; background-size:contain; background-position: center; position: relative; margin-bottom: 10px'" :src="image">
                                    <div class="btn warning" style="position: absolute; top: 0.5rem; left: 0.5rem;" v-on:click="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].data.splice(index,1)">Slet</div>
                                </div>

                                <h5>Upload flere billeder</h5>
                                <input type="file" @change="previewImage" accept="image/*">

                                <div v-if="imageList.length>1">
                                    <h5 class="override">Egenskaber for slideshow</h5>
                                    <span>Visningstid</span>
                                    <span class="description">Angiv tiden i sekunder. Tiden skal være mere end 0.</span>
                                    <input type="number" placeholder="f.eks. 5" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].time.wait">

                                    <span>Overgangstid</span>
                                    <span class="description">Angiv tiden i sekunder. Angiv 0 for at fjerne overgang.</span>
                                    <input type="number" placeholder="f.eks. 1" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].time.in">
                                </div>
                            </div>

                            <!-- Hvis det er af typen Ekstern hjemmeside -->
                            <div v-if="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type == 3">
                                <h5>Hent fra url: </h5>
                                <input type="text" placeholder="Link" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].data">
                            </div>

                            <div v-if="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type == 4">
                                <h5>Rå data </h5>
                                <textarea placeholder="html" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].data">

                                </textarea>
                            </div>

                            <div v-if="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].type == 5">
                                <h5>Hent CSV fra url: </h5>
                                <input type="text" placeholder="Link" v-model="currentDisplay.settings.elements[currentDisplay.settings.selectedElement].data">
                            </div>

                            <div class="btn warning" style="margin-top: 5px" v-on:click="currentDisplay.settings.elements.splice(currentDisplay.settings.selectedElement,1); currentDisplay.settings.selectedElement=null;">Slet element </div>

                        </div>
                    </div>

                    <div class="final-actions">
                        <div class="btn" v-on:click="saveView()">Gem indstillinger</div>
                        <div class="btn warning" v-on:click="deleteViewKey = true">Slet visning</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END OF VIEWS-->
        <!-- START OF UNITS-->
        <div class="content devices" v-else>
            <div class="device-select">
                <h3 class="screen-title">Enheder ({{devices.length}})</h3>
                <div class="screens">
                    <router-link v-for="device in devices" v-bind:key="device.id" :style="'background-color: ' + device.color + ''" tag="div" :to="'/admin/devices/' + device.id">
                        <span class="name">{{device.name}}</span>
                        <span class="id">{{device.id}}</span>
                    </router-link>
                    <div class="add-new" v-on:click="addNewDevice=true">
                        <span class="plus">+</span>
                        <span>Tilføj enhed</span>
                    </div>
                </div>
            </div>
            <div class="device-details" v-if="selectedDevice">
                <div class="settings">
                    <div>
                        <h4>Generelt</h4>
                        <span>Kaldenavn</span>
                        <input type="text" placeholder="Navn" v-model="selectedDevice.name">
                        <span>Farve</span>
                        <input type="color" v-model="selectedDevice.color">
                        <span>Nuværrende visning</span>
                        <select v-model="selectedDevice.current_display">
                            <option v-for="view in views" :value="view.id" :key="view.id">{{view.name}}</option>
                        </select>

                        <span>UUID</span>
                        <a :href="'/'+selectedDevice.uuid" target="_blank">{{selectedDevice.uuid}}</a>
                    </div>

                    <div class="final-actions">
                        <div class="btn" v-on:click="saveDevice()" save>Gem indstillinger</div>
                        <div class="btn warning" v-on:click="removeDeviceKey = true" save>Fjern enhed</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import loginApi from '@/plugins/login-api'
import { VueEditor, Quill } from 'vue2-editor'
import { ImageDrop } from 'quill-image-drop-module'
 
Quill.register('modules/imageDrop', ImageDrop)

export default {
    name:'admin',
    data(){
        return{
            pageedit: false,
            interval:null,
            settings: 1,
            scale: 0,
            account:[],
            addNewDevice: false,
            newpin: null,
            newView: {
                show: false,
                color: "#00838f",
                name: "",
            },
            deleteViewKey: false,
            removeDeviceKey: false,
            devices: [],
            views: [],
            editorSettings: {
                modules: {
                    imageDrop: true
                }
            }
        }
    },
  components: {
    VueEditor,
  },
  mounted() {
        this.checkQuery();
        this.checklogin();
        this.previewFixScale();
        this.interval = setInterval(() => {
            this.timerView();
        },1000);
  },
  sockets: {
    loginOK() {
        this.loadViews();
        this.loadDevices();
    }
  },
  watch: {
    'currentDisplay.settings': function () {
        this.pageedit = true;
    },
    '$route.params.param1': function () {
        this.previewFixScale();
    },
    '$route.params.param2': function () {
        this.previewFixScale();
    },
    'settings': function () {
        console.log("FIIXASDA");
        this.$nextTick(function() {
            this.fixScale();
        })
    }
  },
  created: function () {
    window.addEventListener('beforeunload', function () {
      if(this.pageedit){
          return "Du har ikke gemt dine settings, er du sikker på du vil forsætte?";
      }else{
          return true;
      }
    }, false)
  },
  computed: {
      selectedDevice: function(){
          return this.devices.filter((device) => { return device.id == this.$route.params.param2})[0]
      },
      currentDisplay: function(){
          return this.views.filter((view) => { return view.id == this.$route.params.param2})[0]
      },
      imageList: function(){
          if(Array.isArray(this.currentDisplay.settings.elements[this.currentDisplay.settings.selectedElement].data)){
            return this.currentDisplay.settings.elements[this.currentDisplay.settings.selectedElement].data;
          }else{
            return [];
          }
      }
  },
  methods: {
    timerView: function(){
        var now = new Date();
        var list = document.getElementsByClassName("dateReplace");
            for(var i = 0; i < list.length; i++)
            {
                if(list[i].classList.contains("dayname")){
                    list[i].innerText = ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"][now.getDay()];
                }else if (list[i].classList.contains("monthname")){
                    list[i].innerText = ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"][now.getMonth()];
                }else if (list[i].classList.contains("day")){
                    list[i].innerText = now.getDate();
                }else if (list[i].classList.contains("year")){
                    list[i].innerText = now.getFullYear();
                }else if (list[i].classList.contains("month")){
                    list[i].innerText = now.getMonth()+1;
                }else if (list[i].classList.contains("hours")){
                    list[i].innerText = ("0" + now.getHours()).slice(-2);
                }else if (list[i].classList.contains("minuts")){
                    list[i].innerText = ("0" + now.getMinutes()).slice(-2);
                }else if (list[i].classList.contains("sec")){
                    list[i].innerText = ("0" + now.getSeconds()).slice(-2);
                }
            }
      },
    previewBackgroundImage: function(event) {
        var input = event.target;
        var FileSize = input.files[0].size / 1024 / 1024;
        if (input.files && input.files[0] && FileSize<20) {
            var reader = new FileReader();
            reader.onload = (e) => {
                var image = new Image();
                image.src = e.target.result;
                var vue = this;
                image.onload = function () {
                    vue.currentDisplay.settings.containerSettings.backgroundImage = e.target.result;
                };
            }
            reader.readAsDataURL(input.files[0]);
        }
    },
    previewImage: function(event) {
        var input = event.target;
        var FileSize = input.files[0].size / 1024 / 1024;
        if (input.files && input.files[0] && FileSize<20) {
            var reader = new FileReader();
            reader.onload = (e) => {
                var image = new Image();
                image.src = e.target.result;
                var vue = this;
                image.onload = function () {
                    console.log(e.target.result);
                    vue.$socket.client.emit('uploadImage',e.target.result, (error, response) => {
                        var fileurl = "https://api.screen.itmaster.dk/"+response;
                        //var fileurl = "http://localhost:3000/"+response;
                        console.log("asdasd : "+fileurl);
                        if(Array.isArray(vue.currentDisplay.settings.elements[vue.currentDisplay.settings.selectedElement].data)){
                            vue.currentDisplay.settings.elements[vue.currentDisplay.settings.selectedElement].data.push(fileurl);
                        }else{
                            vue.currentDisplay.settings.elements[vue.currentDisplay.settings.selectedElement].data = [fileurl];
                        }
                        vue.$forceUpdate();
                    })

                };
            }
            reader.readAsDataURL(input.files[0]);
        }
    },
    getElementID: function(){
        let max = 0;
        this.currentDisplay.settings.elements.forEach(ele =>{if(ele.id>max){max = ele.id}});
        return max+1;
    },
    newResolution: function(x,y){
        this.currentDisplay.settings.containerSettings.height=x;
        this.currentDisplay.settings.containerSettings.width=y;
        this.$nextTick(function() {
            this.fixScale()
        })
    },
    previewFixScale: function(){
        this.$nextTick(function() {
            window.addEventListener('resize', this.fixScale);
            this.fixScale()
        })
    },
    geturl(){
        return btoa(document.URL)
    },
    clearLogin() {
        delete localStorage.token
        this.$router.go('/');
    },
    setAccountData(dataextract) {
        if(dataextract.data.id){
            console.log(dataextract);
            console.log(localStorage.token)
            this.account = dataextract.data
        }else{
            this.clearLogin();
        }
    },
    checkQuery(){
        if(this.$route.query.auth){
            localStorage.token = this.$route.query.auth;
            window.location = window.location.origin+window.location.pathname;
        }
    },
    checklogin() {
        if (!localStorage.token && this.$router.path !== '/') {
            window.location = 'https://auth.infrequent.net/login/'+this.geturl();
            console.log('going here: '+'https://auth.infrequent.net/login/'+this.geturl());
        }else{
            loginApi().post('/login/logged',{})
                .then(response => this.setAccountData(response))
                .catch(() => this.clearLogin())
        }
    },
    saveView: function(){
        this.$socket.client.emit('updateViews',{name:this.currentDisplay.name,color:this.currentDisplay.color,settings: this.currentDisplay.settings,html:this.contentRender(),id:this.$route.params.param2}, (error, response) => {
            console.log(response);
            if(error=='200'){
                this.pageedit = false;
                console.log("SAVED")
            }else{
                console.log("error SAVE")
            }
        })
    },
    loadViews: function(){
        var vue = this;
        this.$socket.client.emit('getViews',null, (error, response) => {
            console.log(response);
            if(error=='200'){
                vue.views = response;
                vue.previewFixScale();
            }else{
                vue.devices = [];
            }
        })
    },
    loadDevices: function(){
        var vue = this;
        this.$socket.client.emit('getDevices',null, (error, response) => {
            console.log(response);
            if(error=='200'){
                vue.devices = response;
            }else{
                vue.devices = [];
            }
        })
    },
    claimDevice: function(){
        if(this.newpin){
            var vue = this;
            this.$socket.client.emit('claimDevice',vue.newpin, (error, response) => {
                if(error=='200'){
                    vue.loadDevices();
                    vue.addNewDevice = null;
                }else{
                    console.log(response);
                }
            })
        }
        this.newpin = null;
    },
    removeDevice: function(){
        var vue = this;
        this.$socket.client.emit('unClaimDevice',this.selectedDevice.id, (error, response) => {
            if(error=='200'){
                vue.loadDevices();
                vue.removeDeviceKey = null;
            }else{
                console.log(response);
            }
        })
    },
    saveDevice: function(){
            var vue = this;
            this.$socket.client.emit('saveDevice',this.selectedDevice, (error, response) => {
                if(error=='200'){
                    vue.loadDevices();
                    vue.addNewDevice = null;
                }else{
                    console.log(response);
                }
            })
    },
    addView: function(){
        if(this.newView.color && this.newView.name){
            var vue = this;
            
            this.$socket.client.emit('createView',{color:this.newView.color,name:this.newView.name}, (error, response) => {
                if(error=='200'){
                    vue.loadViews();
                    vue.newView.show = false;
                    vue.newView.name = null;
                    vue.newView.color = this.randomColor();
                }else{
                    console.log(response);
                }
            })
        }
    },
    deleteView: function(){
        var vue = this;
        this.$socket.client.emit('deleteView',{id:this.currentDisplay.id}, (error, response) => {
            if(error=='200'){
                vue.loadViews();
                vue.deleteViewKey = false;
            }else{
                console.log(response);
            }
        })
    },
    fixScale() {
        try{
            var windowHeight = document.getElementById("preview").offsetHeight;
            var windowWidth = document.getElementById("preview").offsetWidth;
            var contentHeight = document.getElementById("preview-border").offsetHeight;
            var contentWidth = document.getElementById("preview-border").offsetWidth;
            if((windowHeight/windowWidth) > (contentHeight/contentWidth)){
                document.getElementById("preview-border").style.transform = "scale(" + (windowWidth/contentWidth) + ")";
                this.scale = Math.round(windowWidth*10000/contentWidth)/100 + "%";
            }else{
                document.getElementById("preview-border").style.transform = "scale(" + (windowHeight/contentHeight) + ")";
                this.scale = Math.round(windowHeight*10000/contentHeight)/100 + "%";
            }
        }catch(err){
            console.log();
        }
    },
    addRow: function(){
        this.currentDisplay.settings.containerSettings.rows.push('1fr');
        this.cleanTemplate();
    },
    addCol: async function(){
        this.currentDisplay.settings.containerSettings.columns.push('1fr');
        this.cleanTemplate();
    },
    replaceWords: function(data){
        data = data.replace(/{{dag_navn}}/g, '<span class="dateReplace dayname">dag_navn</span>');//navn på ugedag
        data = data.replace(/{{månedsnavn}}/g, '<span class="dateReplace monthname">måneds navn</span>');//navn på måned
        data = data.replace(/{{Dag_navn}}/g, '<span style="text-transform: capitalize;" class="dateReplace dayname">dag_navn</span>');//navn på ugedag
        data = data.replace(/{{Månedsnavn}}/g, '<span style="text-transform: capitalize;" class="dateReplace monthname">måneds navn</span>');//navn på måned
        
        data = data.replace(/{{dag}}/g, '<span class="dateReplace day">dag</span>');//tidspunkt på måneden
        data = data.replace(/{{år}}/g, '<span class="dateReplace year">år</span>');//årstal
        data = data.replace(/{{måned}}/g, '<span class="dateReplace month">måned</span>');//årstal
        data = data.replace(/{{timer}}/g, '<span class="dateReplace hours">timer</span>');//timetal
        data = data.replace(/{{sekunder}}/g, '<span class="dateReplace sec">sekunder</span>');//timetal
        data = data.replace(/{{minutter}}/g, '<span class="dateReplace minuts">minutter</span>');//minuttal
        return data;
    },
    contentRender: function(){
        this.fixScale();
        var template = "";
        this.currentDisplay.settings.containerSettings.template.forEach(row => {
            template += "'";
            row.forEach(col => {
                if(col == ''){
                    template += ". ";
                }else{
                template += 'grid-' + col + ' ';
                }
            });
            template += "' ";
        });
        var content = "<style>@import url('https://fonts.googleapis.com/css?family=Staatliches&display=swap');</style>";
        content += '<div class="containter" style="height:' + (this.currentDisplay.settings.containerSettings.height - (this.currentDisplay.settings.containerSettings.border*2)) + 
        'px; width:'+(this.currentDisplay.settings.containerSettings.width - (this.currentDisplay.settings.containerSettings.border*2))+
        'px; background-color:'+ this.currentDisplay.settings.containerSettings.backgroundColor+
        '; background-size: cover; background-position: center; background-image: url('+ this.currentDisplay.settings.containerSettings.backgroundImage+
        '); display: grid; grid-gap:'+this.currentDisplay.settings.containerSettings.gap+
        '; margin: ' + this.currentDisplay.settings.containerSettings.border + 
        'px; ' + this.currentDisplay.settings.containerSettings.style + 
        '; grid-template-rows:'+this.currentDisplay.settings.containerSettings.rows.join(" ")+
        '; grid-template-columns:'+this.currentDisplay.settings.containerSettings.columns.join(" ")+
        '; grid-template-areas:'+template+' ">';
        this.currentDisplay.settings.elements.forEach(element => {
            var exclude = "";
            if(("," + this.currentDisplay.settings.containerSettings.template.toString() + ",").includes("," + element.id + ",") == false){
                exclude = "display: none;";
            }
            if(element.type=="1"){ //Tekst
                content += '<div class="' + element.type + '" id="' + element.id + '" style="grid-area: grid-' + element.id + '; ' + element.style + '; ' + exclude + ' overflow: hidden; overflow-wrap: break-word;">' + this.replaceWords(element.content) + '</div>';

            }else if(element.type=="2"){ //Billede
                if(!Array.isArray(element.data)){
                    element.data = [];
                    }
                    var tot = element.data.length;
                    var wait = 5;
                    var transitiontime_in = 1;//sekunder
                    if(!element.time){
                        element.time = {in:1,wait:5};
                    }
                    if(element.time.in){
                        transitiontime_in = element.time.in;
                    }
                    if(element.time.wait){
                        wait = Number(element.time.wait) + Number(transitiontime_in);
                    }
                    content += '<div class="img' + element.type + '" id="img' + element.id + '" style="grid-area: grid-' + element.id + '; ' + exclude + ' overflow: hidden; overflow-wrap: break-word; position: relative;">';
                    for(var image in element.data){
                        content += '<img style="height:100%;width:100%; border:0; position: absolute; top: 0; left: 0; ' + element.style + ';';
                        if(tot>1){
                            content += 'animation-name: xfade'+ element.id +'; animation-duration: '+tot*wait+'s; animation-delay: '+(((tot-1)-image)*wait)+'s; animation-iteration-count: infinite;';
                        }
                        content += '" src="'+element.data[image]+'"></img>';
                    }
                    content += '</div>';
                    if(tot>1){
                        content += "<style> @keyframes xfade" + element.id + "{0% {opacity:0; z-index: 200;} " + ((100/tot) * (transitiontime_in/wait)) + "% { opacity:1; z-index: 400;} " + (100/tot) + "% { opacity:1; z-index: 100;}" + (100/tot* (1.2+(transitiontime_in/wait))) + "% {opacity:1; z-index: 0} 100%{opacity:0; z-index: 0}}";
                        content += "</style>";
                    }

            }else if(element.type=="3"){ //Hjemmeside
                content += '<div class="' + element.type + '" id="' + element.id + '" style="grid-area: grid-' + element.id + '; ' + element.style + '; ' + exclude + ' overflow: hidden; overflow-wrap: break-word;"><iframe style="height:100%;width:100%; border:0;" src="'+element.data+'"></iframe></div>';
            }else if(element.type=="4"){
                content += '<div class="' + element.type + '" id="' + element.id + '" style="grid-area: grid-' + element.id + '; ' + element.style + '; ' + exclude + ' overflow: hidden; overflow-wrap: break-word;">' + this.replaceWords(element.data) + '</div>';          
            }
        });
        content += "</div>"
        return content;
    },
    cleanTemplate: function(){
        var conset = this.currentDisplay.settings.containerSettings;
        conset.template = Array(conset.rows.length).fill('').map(() => Array(conset.columns.length).fill(''))
    },
    randomColor: function(){
        return ['#c62828', '#4527a0', '#283593', '#00838f', '#00695c', '#558b2f', '#ff8f00', '#d84315', '#4e342e', '#455a64'][Math.floor(Math.random() * 10)]
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fixScale);
    clearInterval(this.interval);
  }
}
</script>
<style lang="scss" scoped>
    @import '@/assets/style/adminStyle.scss';
</style>

<style>
.ql-align-center{
    text-align:center;
}
.ql-align-right{
    text-align:right;
}
.ql-align-left{
    text-align:left;
}
.ql-align-justify{
    text-align: justify;
}
ol li.ql-indent-1 {
  counter-increment: list-1;
}
ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}
ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
ol li.ql-indent-2 {
  counter-increment: list-2;
}
ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}
ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}
ol li.ql-indent-3 {
  counter-increment: list-3;
}
ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}
ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}
ol li.ql-indent-4 {
  counter-increment: list-4;
}
ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}
ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}
ol li.ql-indent-5 {
  counter-increment: list-5;
}
ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}
ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}
ol li.ql-indent-6 {
  counter-increment: list-6;
}
ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}
ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}
ol li.ql-indent-7 {
  counter-increment: list-7;
}
ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}
ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}
ol li.ql-indent-8 {
  counter-increment: list-8;
}
ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}
ol li.ql-indent-8 {
  counter-reset: list-9;
}
ol li.ql-indent-9 {
  counter-increment: list-9;
}
ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}
.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}
li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}
.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}
li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}
.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}
li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}
.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}
li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}
.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}
li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}
.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}
li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}
.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}
li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}
.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}
li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}
.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}
li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}
.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}
li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}
.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}
li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}
.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}
li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}
.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}
li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}
.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}
li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}
.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}
li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}
.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}
li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}
.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}
li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}
.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}
li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}






















/* Editor */
.quillWrapper{
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    border-radius: 7px;
    overflow: hidden;
}

.ql-toolbar, .ql-toolbar.ql-snow{
    border: 0 !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    border-radius: 7px;
    z-index: 10;
    position: relative !important;
}

.quill-container, .ql-container.ql-snow{
    border: 0 !important;
    z-index: -1 !important;
    position: initial;
}

.ql-toolbar, .ql-toolbar *{
    box-sizing: content-box !important;
}

.ql-toolbar, .ql-toolbar *:focus{
    outline: none !important;
}

.ql-snow.ql-toolbar button, .ql-snow.ql-toolbar .ql-picker-label, .ql-picker-label{
    transition: background-color 300ms ease;
    border-radius: 3px;
}
.ql-snow.ql-toolbar button:hover, .ql-snow.ql-toolbar .ql-picker-label:hover, .ql-picker-label:hover{
    background-color: rgba(0, 0, 0, 0.1);
}
.ql-picker:not(.ql-background){
    top: 0 !important;
}
.ql-color-picker{
    width: 34px  !important;
    height: 30px  !important;
}

.ql-color-picker .ql-picker-label{
    height: 24px  !important;
    width: 24px !important;
}
.ql-color .ql-picker-options{
    position: relative !important;
    top: 5px !important;
    height: 138px !important;
    width: 138px !important;
    border-radius: 3px;
    border: 0 !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

.ql-snow .ql-toolbar button, .ql-snow.ql-toolbar button{
    width: 22px !important; 
}

.ql-header .ql-picker-options{
    top: calc(100% + 5px) !important;
}

.ql-tooltip.ql-editing:not(.ql-hidden){
    left: 10px !important;
    right: 10px;
    border: 0;
    border-radius: 3px;
    top: -20px !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    display: flex;
    justify-content: space-between;
}
.ql-tooltip.ql-editing input[type="text"]{
    flex-grow: 2;
    border-radius: 3px;
}

.ql-editor{
    overflow-y: auto;
    max-height: 800px;
    z-index: -1 !important;
}
.quill-container{
    z-index: -1 !important;
}

*::-webkit-scrollbar{
    width: 8px;
}
*::-webkit-scrollbar-track{
    background-color: rgba(0, 0, 0, 0.1);
}
*::-webkit-scrollbar-thumb{
    background-color: rgba(0, 0, 0, 0.3);
    background-image: linear-gradient(to bottom, #263238, #37474f);
    overflow: hidden;
}
</style>